import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LeadLost from './icon-lead-lost.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LeadLost {...validProps} />;
}
SvgComponent.iconName = 'leadLost';

/**
 * @deprecated This is a legacy icon
 */
export const LeadLostIcon = svgIconWrapper(SvgComponent);
